import React from 'react';
import { useTranslation } from 'react-i18next';
import rejectedIcon from '../static/icons/rejected.svg';

export const Rejected = (props) => {
  const { t } = useTranslation();

  React.useEffect(() => {
    props.hideLoader();
  }, [props]);

  return (
    <div className="container bg-red-gradient w-full max-w-xs mx-auto">
      <div className="successSubmit px-8 pt-6 pb-8 mb-4 mt-4">
        <img className="object-scale-down h-24 w-full" src={rejectedIcon} alt="Rejected" />
        <br />
        <h1 className="rejectionTitle text-center">{t('Sign in failed!')}</h1>
        <p className="text-center text-white successText">{t('Your submission is not compliant with our health and safety policy.')}</p>
        <p className="text-center text-white successText">{t('Please stay where you are, Management will be contacting you momentarily.')}</p>
      </div>
    </div>
  );
};
